import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { HelpCircle } from "lucide-react";
 * // Use <HelpCircle /> instead
 */
export const HelpIcon = createSVGWrapper(
  <path
    d="M4.5965 4.59669L8.8365 8.83669M14.4965 8.83669L18.7365 4.59669M14.4965 14.4967L18.7365 18.7367M8.8365 14.4967L4.5965 18.7367M21.6665 11.6667C21.6665 17.1895 17.1894 21.6667 11.6665 21.6667C6.14366 21.6667 1.6665 17.1895 1.6665 11.6667C1.6665 6.14384 6.14366 1.66669 11.6665 1.66669C17.1894 1.66669 21.6665 6.14384 21.6665 11.6667ZM15.6665 11.6667C15.6665 13.8758 13.8756 15.6667 11.6665 15.6667C9.45736 15.6667 7.6665 13.8758 7.6665 11.6667C7.6665 9.45755 9.45736 7.66669 11.6665 7.66669C13.8756 7.66669 15.6665 9.45755 15.6665 11.6667Z"
    stroke="currentColor"
    strokeWidth="1.75"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
